import { Button, Grid2 } from '@mui/material'
import React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'
import { i18n } from '../index'

export default function GoBackButton({ stationId, to }: { stationId: string; to: string }) {
  return (
    <Grid2 container direction='row' justifyContent='left'>
      <Grid2>
        <Button component={ReactRouterLink} variant='outlined' to={to}>
          {i18n.t('buttons.back')}
        </Button>
      </Grid2>
    </Grid2>
  )
}
